// Librairies
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

// Tooltip above a point of the viewport (clientX / clientY of a map bubble, a heatmap cell…), in the theme colours.
@Component({
  selector: 'lib-tooltip',
  standalone: true,
  templateUrl: './tooltip.component.html',
  styleUrl: './tooltip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.left.px]': 'x',
    '[style.top.px]': 'y'
  }
})

export class TooltipComponent {
  // Variables
  @Input() x: number = 0;
  @Input() y: number = 0;
}
